module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames0-951912839e2bb1d628f39877eca7ca0d.png";